module.exports = __webpack_public_path__ + "static/media/icita2009.4024efa8.png";